(function() {

  angular
	.module('meanApp')
	.controller('ingredientsCtrl', ingredientsCtrl);

  ingredientsCtrl.$inject = [
  '$location',
  '$state', 
  'measuresManager', 
  'departmentsManager', 
  'allergensManager', 
  'ingredientsManager', 
  'productsManager', 
  'featuresManager',
  'Ingredient', 
  'confirmationModal', 
  '$rootScope', 
  '$uibModal',
  'alert', 
  '$scope'];
  function ingredientsCtrl(
  	$location,
  	$state,
  	measuresManager, 
  	departmentsManager, 
  	allergensManager, 
  	ingredientsManager, 
  	productsManager,
  	featuresManager,
  	Ingredient, 
  	confirmationModal, 
  	$rootScope, 
	$uibModal,
  	alert, 
  	$scope) {

	var vm = this;

	//if on the edition of an ingredient :
	if ($location.path().indexOf('/ingredient/') > -1 && $location.path().indexOf('/edit') > -1) {
		ingredientsManager.get($state.params.slug)
		.then(function(result) {
			vm.ingredient = result;
		}, function(err) {
			console.log('error loading the ingredient');
		});
	}

	vm.ingredients = [];//not used yet
	vm.ingredient = {};
	vm.measures = [];
	vm.departmentOptions = [];
	vm.allMonthsClickedStatus = false;//by default
	vm.ingredient.percentageFruitsAndVegetables = 0;
	//vm.ingredient.isSuperIngredient = false;

	// data for the sizing
	$scope.pixelSideEditor = {
		width: '100px',
		height: '100px'
	};
	$scope.imageSource = '';
	$scope.myCroppedImage = '';
	//$scope.pictureUploading = false;
	$scope.myAeraType = 'square';
	$scope.resultImageSize = 600;

	vm.monthsSoldInFrance = 
	[{ _id: 0, name: 'Jan'},
	{ _id: 1, name: 'Fev' },
	{ _id: 2, name: 'Mar' },
	{ _id: 3, name: 'Avr' },
 	{ _id: 4, name: 'Mai' },
 	{ _id: 5, name: 'Juin'},
 	{ _id: 6, name: 'Juil'},
 	{ _id: 7, name: 'Aou' },
 	{ _id: 8, name: 'Sept'},
 	{ _id: 9, name: 'Oct'},
 	{ _id: 10, name: 'Nov'},
 	{ _id: 11, name: 'Dec'}];

 	vm.onSearchOpenFood = function() {

 		productsManager.search(vm.searchIngredient, 30)
 		.then(function(result) {
			vm.superIngredientsSearchResult = result;
			var categories = {}, 
			categoryValue,
			mostUsedCategory,
			nbResult = vm.superIngredientsSearchResult.length;

			vm.superIngredientsSearchResult.forEach(function(item, indexProduct) {
				//find the most popular categories for the first ingredients
				if(indexProduct < 11) {
					item.categories_hierarchy.forEach(function(category) {
						categoryValue = categories[category];
						categories[category] = (typeof categoryValue !== 'undefined') ? categoryValue+2 : 2;
					});
				}
			});

			console.log('categories are', categories);

			//find the most common category
			Object.keys(categories).forEach(function(key) {
				if(!mostUsedCategory) {
					mostUsedCategory = key;
				}
				else if(categories[key] > categories[mostUsedCategory]){
					mostUsedCategory = key;
				}
			});
			
			vm.superIngredientsSearchResult.forEach(function(item, indexItem) {
				//find the most popular categories
				var score = 0,
				itemCatLength = item.categories_hierarchy.length;
				item.categories_hierarchy.forEach(function(category) {
					categoryValue = categories[category] || 0.6;
					score+= (categoryValue/itemCatLength)/(indexItem+1);//make it square so it is even mote insignificant if only product within a category
				});
				console.log('score is ', score);
				item.selected = score >=1;
			});
			
		}, function(err) {
			console.log('erreur loading search results from OpenFood');
			console.log(err);
		});
 	};

 	vm.onAllMonthsClicked = function() {
 		vm.monthsSoldInFrance.forEach(function(item) {
 			item.active = !vm.allMonthsClickedStatus;
 		});
 		vm.allMonthsClickedStatus = !vm.allMonthsClickedStatus;
 	};

 	vm.onDepartmentChange = function() {
 		console.log('department id picked is ', vm.ingredient.department);
 		var department = vm.departmentOptions.filter(function(department) {
 			return department._id === vm.ingredient.department;
 		});

 		//only for data coming from
 		if(department[0] && vm.isOpenFoodDB !== true) {
 			vm.probableAllergens= department[0].probableAllergens;
 			vm.probableFeatures= department[0].probableFeatures;

 			//and reinit the allergenrisk and features
 			//vm.ingredient.allergensRisk= [];
 			//vm.ingredient.features= [];
 		}	
 	};

	var setOptimizedWidthAndHeight = function(width, height) {
		//compute a square but not larger than 400px max
		var minSide = Math.min(width, height),
			minSideIsWidth = minSide === width,
			effectiveSide = 100,
			effectiveHeight,
			effectiveWidth;

		if (minSide > 400) {
			effectiveSide = 400;
		} else if (minSide > 100) {
			effectiveSide = minSide;
		}

		if (!minSideIsWidth) {
			effectiveWidth = effectiveSide;
			effectiveHeight = parseInt(effectiveWidth * height / width, 10);
		} else {
			effectiveHeight = effectiveSide;
			effectiveWidth = parseInt(width * effectiveHeight / height, 10);
		}

		var widthAvailable = window.document.getElementsByClassName('website-container')[0].offsetWidth - 20; //remove the margins

		//regulate the width
		if (widthAvailable < effectiveWidth) {
			effectiveWidth = widthAvailable;
			effectiveHeight = parseInt(height * effectiveWidth / width);
		}

		$scope.pixelSideEditor = {
			width: effectiveWidth + 'px',
			height: effectiveHeight + 'px'
		};
	};

	vm.onFileChange = function(imageSource, width, height) {
			$scope.imageSource = imageSource;
			console.log('image width is ' + width, 'height', height);

			setOptimizedWidthAndHeight(width, height);
		
			//here open a modal in order to edit the picture
			vm.modal = $uibModal.open({
				templateUrl: 'profile/change.picture.modal.view.html',
				scope: $scope,
				backdrop: 'static'
			});
			
			vm.modal.rendered.then(function() {
				console.log('modal change picture is rendered');
				//this.document.body.get modal-content
				var widthAvailable = window.document.getElementsByClassName('modal-content')[0].offsetWidth - 20;
				//what if prortrait image ?
				if (widthAvailable < width) {
					$scope.pixelSideEditor = {
						width: widthAvailable + 'px',
						height: parseInt(height * widthAvailable / width) + 'px'
					};
					//$scope.$apply();
				}
			});
		};
	
	var dataURLtoFile = function(dataurl, filename) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([ u8arr ], filename, { type: mime });
	};

		

	//TODO rename the function to someone more generic
	$scope.saveProfilePicture = function() {
		var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'recipe'),
			fd = new FormData();
		fd.append('file', fileBuiltFromeBase64); //pass the file newly created

		/**Object.keys(vm.recipe).forEach(function(key) {
			fd.append(key, JSON.stringify((vm.recipe[key])));
		});**/
		console.log($scope, this);
		//$scope.pictureUploading = true;
		//this.pictureUploading = true;
		console.log('the filename is', fileBuiltFromeBase64.filename);
		//put the button in loading mode

		console.log('the recipe object is', vm.ingredient);
		if (vm.ingredient._id) {
			console.log('todo save ingredient picture to back end')
			vm.ingredient.updateWithPicture(fd).then(function(ingredient) {
				vm.modal.close()
				alert.push('success', 'Image sauvegardée')
			})
			//save using PUT with just the image
			/**vm.recipe.updateWithPicture(fd).then(function(recipe) {
				//then get the ID and put it into the recipe object :)
				//angular.extend(vm.recipe, recipe);
				//vm.recipe = recipe;
				//console.log('thumb construction', vm.recipe.getThumb('s'));

				this.modal.close();
				alert.push('success', 'Image sauvegardée');
			}.bind(this), function(error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', "Votre image n'a pu être sauvegardée");
			});**/
		} else {
			// create and POST the recipe
			//TODO transform the recipe in a suitable structure for the API
			/**var newRecipe = new Recipe(vm.recipe); //pass the parameters as init
			newRecipe.saveAsDraft(fd).then(function(recipe) {
				//then get the ID and put it into the recipe object :)
				//angular.extend(vm.recipe, recipe);
				vm.recipe = recipe;
				console.log('thum construction', vm.recipe.getThumb('s'));

				this.modal.close();
				alert.push('success', 'Image sauvegardée');
			}.bind(this), function(error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', "Votre image n'a pu être sauvegardée");
			});**/
		}
	};

 	vm.onPrefillClick = function () {
 		//TODO set more matching between allergens and easyIDs
 		//TOOD put the stuff in the allergen model or somewhere else but not here
 		var matchingBetweenOpenFoodAllergensAndEasyID = {
 			'en:gluten' : 0,
            'en:milk': 6,
            'en:eggs': 2 ,
            'en:mustard': 9,
            'en:fish': 3
 		},
 		allergenFiltered=[],
 		featureFiltered =[];

 		//1- prefill the probableAllergens and features
 		vm.probableAllergens= vm.allergens;
 		//for each allergen proba set active in the
 		vm.allergensProbability.forEach(function(allergenRisk) {
 			//set the risk and if active
 			var allergenFiltered = vm.probableAllergens.filter(function(allergen) {
 				return allergen.easyID === matchingBetweenOpenFoodAllergensAndEasyID[allergenRisk.name];
 			});

 			if(allergenFiltered[0]) {
 				allergenFiltered[0].risk = allergenRisk.percent;
 				allergenFiltered[0].active = true;
 				allergenFiltered[0].risk = allergenFiltered[0].getRisk();
 			}

 		});

 		vm.probableFeatures= vm.features;
 		vm.probableFeatures.forEach(function(feature) {
 			var selected, filtered, isFeature;
 			switch (feature.easyID) {
				case 0:
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
				case 7:
				case 8:
				  	//for each ingredient must have the ID feature
				  	selected = true;
				  	vm.matchedIngredients.forEach(function(ingredient) {
				  		//take the ingredient selected
				  		match = ingredient.matches.filter(function(item) {
				  			return item.selected === true;
				  		});
				  		if (match[0]) {
				  			//now check the presence of the feature or not
				  			isFeature = match[0].features.filter(function(featureItem) {
				  				return featureItem.easyID === feature.easyID;
				  			});
				  			selected = selected && isFeature.length > 0;
				  		}
				  	});
			  	break;
			  	case 6:
			  		selected = false;
				  	vm.matchedIngredients.forEach(function(ingredient) {
				  		//take the ingredient selected
				  		match = ingredient.matches.filter(function(item) {
				  			return item.selected === true;
				  		});
				  		if (match[0]) {
				  			//now check the presence of the feature or not
				  			isFeature = match[0].features.filter(function(featureItem) {
				  				return featureItem.easyID === feature.easyID;
				  			});
				  			selected = selected || isFeature.length > 0;
				  		}
				  	});
			    break;
			  	default:
			    	console.log('nothing to do');
			}

			feature.active = selected;


 		});
		
		var measures;
		//now fill the quantities
		if(vm.isLiquid) {
			//check the ml measure
			measures = vm.measures.filter(function(measure) {
				return measure.easyID === 2;
			});
			if(measures[0]) {
				measures[0].active = true;
				vm.onMeasureChange(measures[0]);
			}
		}
		else {
			//check the g measure
			measures = vm.measures.filter(function(measure) {
				return measure.easyID === 0;
			});
			if(measures[0]) {
				measures[0].active = true;
				vm.onMeasureChange(measures[0]);
			}
		}

		vm.ingredient.novaGroup = parseInt(vm.algoResult.averageNovaGroup.average);
		vm.ingredient.percentageFruitsAndVegetables = vm.algoResult.averageFruitsAndVegetables.average;
 	};

	$rootScope.$watch('currentUser', function () {
		if ($rootScope.currentUser) {
			if($rootScope.currentUser.role === 'admin'){
				loadIngredients();
				loadAllergens();
				loadFeatures();
				loadDepartments();
				loadMeasures();
			}
			else {
				$location.path('/');
			}
		}
	}, function(err) {
		console.log(err);
	});

	var loadAllergens = function() {
		allergensManager.getAll()
		.then(function(result) {
			vm.allergens = result.collection;
		}, function(err) {
			console.log('error loading all allergens');
		});
	};

	var loadFeatures = function() {
		featuresManager.getAll()
		.then(function(result) {
			vm.features = result.collection;
		}, function(err) {
			console.log('error loading all features');
		});
	};

	var fillFeatures = function() {
		vm.probableFeatures = vm.features;
		var IDs = [];
		vm.ingredient.features.forEach(function(feature) {
			IDs.push(feature._id);
		});

		vm.probableFeatures.forEach(function(feature) {
			feature.active = IDs.indexOf(feature._id) > -1;
		});
	};

	var fillAllergens = function() {
		var IDs = [];
		vm.ingredient.allergensRisk.forEach(function(allergenRisk) {
			if(allergenRisk.risk) {
				IDs.push(allergenRisk.allergen._id);
			}
		});
		vm.probableAllergens = vm.allergens;
		vm.probableAllergens.forEach(function(allergen) {
			allergen.active = IDs.indexOf(allergen._id) > -1;
			if(allergen.active === true) {
				vm.ingredient.allergensRisk.forEach(function(allergenRisk) {
					if(allergenRisk.allergen._id === allergen._id) {
						allergen.risk = allergenRisk.risk;
					}
				});
			}
		});
	};

	var fillMeasures = function() {
		/**var IDs = [];
		vm.ingredient.measures.forEach(function(measure) {
			IDs.push(measure._id);
		});**/

		vm.measures.forEach(function(measure) {
			measure.active = vm.ingredient.measures.indexOf(measure._id) > -1;
		});
		console.log('measures updated ', vm.measures);
	};

	var loadMeasures = function() {
		measuresManager.getAll()
		.then(function(result) {
			vm.measures = result.collection;
			var measure, l=vm.measures.length;
			for (var i=0, l; i<l; i++) {
				measure= vm.measures[i];
				measure.active = false;//to be merged for editing
				//to be merged when editing the measures
			}
		}, function(err) {
			console.log('error loafing all measures');
		});
	};

	var findMeasure = function(easyID) {
		var arrayMeasureFiltered = vm.measures.filter(function(measure) {
 			return measure.easyID === easyID;
 		});
 		
 		return arrayMeasureFiltered[0] || null;
	};

	vm.onMeasureChange = function(measure) {
		var easyID = measure.easyID;
		//g and kg are the same
		if(easyID === 0) {
			findMeasure(1).active = measure.active;
		}
		if(easyID === 1) {
			findMeasure(0).active = measure.active;
		}

		//if g is set the others liquid are opposite
		if(easyID < 2 && measure.active) {
			findMeasure(2).active = !measure.active;
			findMeasure(3).active = !measure.active;
			findMeasure(4).active = !measure.active;
		}

		//ml cl and cl are the same
		if (easyID === 2) {
			findMeasure(3).active = measure.active;
			findMeasure(4).active = measure.active;
		}
		if (easyID === 3) {
			findMeasure(2).active = measure.active;
			findMeasure(4).active = measure.active;
		}
		if (easyID === 4) {
			findMeasure(3).active = measure.active;
			findMeasure(2).active = measure.active;
		}

		//if cl is set the others g are opposite and spoons are reset too
		if(easyID > 1 && easyID <5 && measure.active) {
			findMeasure(0).active = !measure.active;
			findMeasure(1).active = !measure.active;
			if(measure.active === true) {
				findMeasure(5).active = true;
				findMeasure(6).active = true;
			}
		}

		//spoons quantities are always the same
		if(easyID === 5) {
			findMeasure(6).active = measure.active;
		}
		if(easyID === 6) {
			findMeasure(5).active = measure.active;
		}

		if(easyID === 7) {
			//if portion is selected make a field appear
			if (measure.active) {
				if(vm.algoResult) {
					vm.ingredient.servingQuantity = vm.algoResult.averageQuantity.average ? vm.algoResult.averageQuantity.average : 0;
				}
				else {
					vm.ingredient.servingQuantity = 100;
				}
			}
			else {
				vm.ingredient.servingQuantity = 0;
			}
		}
		
 	};

	var loadDepartments = function() {
		departmentsManager.getAll()
		.then(function(result) {
			vm.departmentOptions = result.collection;
			vm.departmentOptions.forEach(function(item, index) {
				if(index < 4) {
					item.type= "Légumes";
				}
				else if( index < 8) {
					item.type= "Fruits";
				}
				else if(index< 13){
					item.type = "Boucherie";
				}
				else if(index< 18){
					item.type = "Charcuterie";
				}
				else if(index< 22){
					item.type = "Poissonnerie";
				}
				else if(index< 26){
					item.type = "Boulangerie";
				}
				else if(index< 31){
					item.type = "Lait, Beurre, Oeufs";
				}
				else if(index< 41){
					item.type = "Fromages";
				}
				else if(index< 46){
					item.type = "Yaourts";
				}
				else if(index< 51){
					item.type = "Desserts";
				}
				else if(index< 54){
					item.type = "Eaux";
				}
				else if(index< 59){
					item.type = "Jus de fruits, sodas";
				}
				else if(index< 62){
					item.type = "Bières et cidres";
				}
				else if(index< 65){
					item.type = "Spiritueux";
				}
				else if(index< 71){
					item.type = "Vins et Champagnes";
				}
				else if(index< 82){
					item.type = "Epicerie salée";
				}
				else if(index< 88){
					item.type = "Epicerie sucrée";
				}
				else if(index< 95){
					item.type = "Petit déjeuner";
				}
				else if(index< 97){
					item.type = "Produits du monde";
				}
				else if(index< 99){
					item.type = "Dessert";
				}
			});
			
			//for each department add a group type
			vm.onDepartmentChange();//in order to set the allergens and the features
			
			if ($location.path().indexOf('/ingredient/') > -1 && $location.path().indexOf('/edit') > -1) {
				//fill features
				fillFeatures();
				fillAllergens();
				fillMeasures();

				vm.monthsSoldInFrance.forEach(function(monthNumber) {
					monthNumber.active = vm.ingredient.monthsSoldInFrance.indexOf(monthNumber._id)> -1;
				});
			}

			//vm.monthsSoldInFrance.
		}, function(err) {
			console.log('error loafing all departments for ingredients creation');
		});
	};

	var loadIngredients = function () {
		//TODOdo a pagination
	  	ingredientsManager.getAll()
	  	.then(function(result) {
			vm.ingredients = result.collection;
	  	}, function(err) {
			console.log('erreur loading all profiles');
			console.log(err);
	  	});
	};

	vm.onAddIngredient = function(isEditMode) {
		//reinit the values
		vm.ingredient.measures = [];
		vm.ingredient.monthsSoldInFrance = [];
		vm.ingredient.allergensRisk= [];
 		vm.ingredient.features= [];

		var reducedArray = [];
		//retrieve the measures and put it on the ingredient structure
		if (vm.measures && vm.measures.length > 0) {
			reducedArray = vm.measures.filter(function(item) {
				return item.active === true;
			});

			reducedArray.forEach(function(item){
			  	vm.ingredient.measures.push(item._id);
			});
		}

		reducedArray = vm.monthsSoldInFrance.filter(function(item) {
			return item.active === true;
		});

		reducedArray.forEach(function(item){
		  	vm.ingredient.monthsSoldInFrance.push(item._id);
		});

		if (vm.probableAllergens && vm.probableAllergens.length >0) {
			reducedArray = vm.probableAllergens.filter(function(item) {
				return item.active === true;
			});

			reducedArray.forEach(function(item) {
				vm.ingredient.allergensRisk.push({
					risk: item.risk || 'HIGH', //by default risk is high
					allergen: item._id
				});
			});
		}

		if (vm.probableFeatures && vm.probableFeatures.length >0) {
			reducedArray = vm.probableFeatures.filter(function(item) {
				return item.active === true;
			});

			reducedArray.forEach(function(item) {
				vm.ingredient.features.push(item._id);
			});
		}

		if(vm.matchedIngredients) {
			var matchedIngredient;
			vm.ingredient.ingredients = [];
			vm.matchedIngredients.forEach(function(ingredient) {
				matchedIngredient = ingredient.matches.filter(function(match) {
					return match.selected === true;
				});
				if(matchedIngredient[0]) {
					vm.ingredient.ingredients.push(matchedIngredient[0]._id);
				}
			});
		}

		var matchingNutrientKeyDB = {
			'averageFiber': 291,
			'averageEnergy': 208,
			'averageCarbohydrates': 205,
			'averageFat': 204,
			'averageSaturatedFat': 606,
			'averageProtein': 203,
			'averageSodium': 307,
			'averageSugar': 269
		};

		//read all the keys
		var nutrientsQuantity = [];
		if(vm.algoResult) {
			Object.keys(vm.algoResult).forEach(function(key) {
				if(matchingNutrientKeyDB[key]) {
					nutrientsQuantity.push({
						quantity: vm.algoResult[key].average,
						nutrient: matchingNutrientKeyDB[key]
					});
				}
			});
		}
		

		if(nutrientsQuantity.length) {
			vm.ingredient.nutrientsQuantity = nutrientsQuantity;
		}

		if(vm.sortedProducts) {
			vm.ingredient.IDOpenDB = vm.sortedProducts[vm.indexProductChosen].id;
		}

		console.log(vm.ingredient);
		
		if(isEditMode === true) {
			vm.ingredient.update(vm.ingredient).then(function() {
				alert.push('success', "L'ingrédient a été mis à jour");
			}, function() {
				alert.push('danger', "L'ingrédient n'a pas été mis à jour, veuillez réessayer ultérieurement");
			});
		}
		else {
			var newIngredient = new Ingredient(vm.ingredient);
			newIngredient.save()
			.then(function (ingredient) {
				var instanceIngredient = ingredientsManager.set(ingredient);
				vm.ingredients.push(instanceIngredient);
				alert.push('success', 'Nouvel ingrédient ajouté en base de données');
			}, function (error) {
				//TODO préciser si déja en base de données ou quoi
				alert.push('danger', 'Ingredient non ajouté en base de données');
			});
		}
	};

	vm.confirmationQuestion = 'Voulez vous vraiment supprimer cet ingrédient ?';
	vm.onConfirmationModalClick = function() {
		ingredientsManager.delete($scope.ingredientIDToDelete)
		.then(function() {
			this.$close();
	  		alert.push('success', 'Cet ingrédient a été supprimé définitivement de la base de données');
	  	}.bind($scope), function() {
	  		this.$close();
	  		alert.push('danger', "Cet ingrédient n'a pas pu être supprimé");
	  	}.bind($scope));
	};
	
	vm.removeIngredient = function(id) {
		$scope.ingredientIDToDelete = id;
		$scope.modalInstance = confirmationModal.open($scope, 'ingredientsCtrl');
	};

	var setMatchingIngredients = function(product, onComplete, onFailure) {
		var ingredientOfProduct = product.ingredients,
		ingredientName, index = 0, length = ingredientOfProduct.length;
		
		ingredientOfProduct.forEach(function(ingredient) {
			ingredientName = ingredient.text;
			//TODO maybe here remove some unwanted characters (set a list of carachters to be removed ?)
			ingredientName = ingredientName.replace(new RegExp('_', 'g'), '');
			ingredientsManager.search(ingredientName)
		  	.then(function(results) {
		  		//TODO if no result for one of the ingredient then return the onFailure callback function !!!
		  		if(results[0]) {
		  			results[0].selected = true;//always select first item returned
		  		}
		  		this.matches = results;
		  		index++;
		  		if(index === length) {
		  			onComplete();
		  		}
				//TODO send result to view only when ALL ingredients have been computed
				//TODO 2 what about if there is never a product that can fit all ingredients ?
		  	}.bind(ingredient), function(err) {
				console.log('erreur loading all profiles');
				console.log(err);
		  	});
		});
	};

	vm.onMatchedIngredientClick = function(matchedIngredient, ingredientMatches) {
		ingredientMatches.forEach(function(item) {
			item.selected = item._id === matchedIngredient._id;
		});
	};	

	//this remove ingredient from the matching ingredients
	vm.onRemoveMatchedIngredient = function(ingredient, matchedIngredients) {
		vm.matchedIngredients = matchedIngredients.filter(function(ingredientItem) {
			return ingredientItem.id !== ingredient.id;
		});
	};

	vm.onAlgorithmClick = function() {
		//0- products that have been unselected
		//0.1 TODO maybe try to find the irrelevant products and eliminate them (by department maybe ???)
		//1- find all the products that have been selected

		var productsFiltered = vm.superIngredientsSearchResult.filter(function(product) {
			return product.selected === true;//temporary until we have test terminated
		}),
		averages = {
			averageNovaGroup :{},
			averageFruitsAndVegetables:{},
			averageFiber:{}, //fibres
			averageEnergy:{},//en KJ 
			averageCarbohydrates:{},//glucides
			averageFat:{},//all the fat
			averageSaturatedFat:{}, //saturated fat
			averageQuantity:{},
			averageProtein:{}, //proteines
			averageSalt:{},//sel
			averageSodium:{},//sodium
			averageSugar:{},//sucres
		},
		allergensCount = {},
		liquidCount=0,
		solidCount=0;

		Object.keys(averages).forEach(function(key) {
			averages[key] = {
				counter: 0,
				average: 0
			};
		});

		//2- compute the average:
			//2.1 nova
			//2.2 nutriscores //no must be computed later on
			//2.3 percentageFruitsAndVegetables
			//2.4 nutriments facts including fiber
			//2.5 what allergens are high risk or low risk  
				//2.6 if only low risk then extend the search number ? and go to 1.

		productsFiltered.forEach(function(product, index) {
			//TEMPORARY TRY to find all the product quantity and the quantity itself

			var nutriments = product['nutriments'],
			nova_group = product['nova_group'],
			fruits_vegetables_nuts_100g_estimate = product['fruits-vegetables-nuts_100g_estimate'],
			product_quantity = product['product_quantity'],
			quantity = product['quantity'] ? product['quantity'].toLowerCase() : '',
			allergens = product['allergens_tags'];

			allergens.forEach(function(allergen) {
				var counter = allergensCount[allergen];
				if(typeof counter === 'undefined') {
					allergensCount[allergen] = 1;
				}
				else {
					allergensCount[allergen]++;
				}
			});

			if(quantity.indexOf(' l') > 0 || quantity.indexOf(' cl') > 0 || quantity.indexOf(' ml') > 0) {
				liquidCount++;
			}
			if(quantity.indexOf(' g') > 0) {
				solidCount++;
			}

			//TODO factorize all these function, amount of lines can be reduced
			if(typeof nova_group !== 'undefined' && parseFloat(nova_group) > 0) {
				averages['averageNovaGroup'].average+= parseFloat(nova_group);
				averages['averageNovaGroup'].counter++;
			}
			if(typeof fruits_vegetables_nuts_100g_estimate !== 'undefined' && parseFloat(fruits_vegetables_nuts_100g_estimate) > 0) {
				averages['averageFruitsAndVegetables'].average+= parseFloat(fruits_vegetables_nuts_100g_estimate);
				averages['averageFruitsAndVegetables'].counter++;
			}
			if(typeof nutriments.fiber_100g !== 'undefined' && parseFloat(nutriments.fiber_100g)  > 0) {
				averages['averageFiber'].average+= parseFloat(nutriments.fiber_100g);
				averages['averageFiber'].counter++;
			}
			if(typeof nutriments.energy_value !== 'undefined' && parseFloat(nutriments.energy_value)  > 0) {
				averages['averageEnergy'].average+= nutriments.energy_unit === 'kcal' ? parseFloat(nutriments.energy_value) : parseFloat(nutriments.energy_value)/4.184; //convert in kcal ? YES otherwise creates issues
				averages['averageEnergy'].counter++;
			}
			if(typeof nutriments.carbohydrates_100g !== 'undefined' && parseFloat(nutriments.carbohydrates_100g)  > 0) {
				averages['averageCarbohydrates'].average+= parseFloat(nutriments.carbohydrates_100g);
				averages['averageCarbohydrates'].counter++;
			}
			if(typeof nutriments.fat_100g !== 'undefined' && parseFloat(nutriments.fat_100g)  > 0) {
				averages['averageFat'].average+= parseFloat(nutriments.fat_100g);
				averages['averageFat'].counter++;
			}
			if(typeof nutriments['saturated-fat_100g'] !== 'undefined' && parseFloat(nutriments['saturated-fat_100g'])  > 0) {
				averages['averageSaturatedFat'].average+= parseFloat(nutriments['saturated-fat_100g']);
				averages['averageSaturatedFat'].counter++;
			}
			if(typeof product_quantity !== 'undefined' && parseFloat(product_quantity) > 0) {
				averages['averageQuantity'].average+= parseFloat(product_quantity);
				averages['averageQuantity'].counter++;
			}

			if(typeof nutriments['proteins_100g'] !== 'undefined' && parseFloat(nutriments['proteins_100g'])  > 0) {
				averages['averageProtein'].average+= parseFloat(nutriments['proteins_100g']);
				averages['averageProtein'].counter++;
			}
			if(typeof nutriments['salt_100g'] !== 'undefined' && parseFloat(nutriments['salt_100g'])  > 0) {
				averages['averageSalt'].average+= parseFloat(nutriments['salt_100g']);
				averages['averageSalt'].counter++;
			}
			if(typeof nutriments['sodium_100g'] !== 'undefined' && parseFloat(nutriments['sodium_100g'])  > 0) {
				averages['averageSodium'].average+= parseFloat(nutriments['sodium_100g']);
				averages['averageSodium'].counter++;
			}
			if(typeof nutriments['sugars_100g'] !== 'undefined' && parseFloat(nutriments['sugars_100g'])  > 0) {
				averages['averageSugar'].average+= parseFloat(nutriments['sugars_100g']);
				averages['averageSugar'].counter++;
			}
		});
	
		//TODO maybe extend the number of products if allergens is always present to see if there is some alternative ???
		Object.keys(averages).forEach(function(key) {
			if(averages[key].counter !== 0) {
				console.log('for '+ key + ' the global sum is' + averages[key].average);
				averages[key].average = averages[key].average/averages[key].counter;
				if(key === 'averageSodium') {
					averages[key].average = averages[key].average *1000; //convert into mg
				}
				if(key === 'averageNovaGroup') {
					averages[key].average = Math.round(averages[key].average);
				}
				averages[key].average = Math.round( averages[key].average * 10 ) / 10;
			}
		});

		vm.algoResult = averages;
		
		console.log(averages);
		console.log(allergensCount);
		console.log('number of products studied'+ productsFiltered.length);
		
		//3- find the ingredients into it by taking the product with the less number of ingredients
		vm.sortedProducts = productsFiltered.sort(function(item1, item2) {
			var length1 = item1.ingredients ? item1.ingredients.length: 0,
			length2 = item2.ingredients ? item2.ingredients.length : 0,
			ans = 0;
			if((length1 === 0 || length2 === 0) && (length1+length2 !== 0)) {
				ans = length1 === 0 ? 1 : -1;
			}
			else if(length1 > length2) {
				ans = 1;
			}
			else if(length1 < length2){
				ans = -1;
			}
			return ans;
		});

		//console.log('Shortest ingredients', productsFiltered[0].ingredients);
		
		vm.allergensProbability= [];
		Object.keys(allergensCount).forEach(function(allergen) {
			vm.allergensProbability.push({
				name : allergen,
				percent: Math.round(100*(allergensCount[allergen]/productsFiltered.length))
			});
		});

		//TEST API TEMPORARY
		//var stringSearch = 'wheat flour';
		vm.indexProductChosen = 0;
		vm.lengthProductChosen = productsFiltered.length;
		//3.1 match by doing search on the ingredients database
		//3.2 if all the ingredients do not match take the second product with less ingredients ?
		
		vm.onNewProductChosen();
		vm.isLiquid = liquidCount > solidCount;
	};

	vm.onNewProductChosen = function(goNext) {
		if(typeof goNext !== 'undefined') {
			console.log('gotnext is', goNext);
			if(goNext === true) {
				vm.indexProductChosen++;
			}
			else {
				vm.indexProductChosen--;
			}
		}
		console.log('typeof indexproduct chosen', typeof vm.indexProductChosen);
		
		setMatchingIngredients(vm.sortedProducts[vm.indexProductChosen], function() {
			vm.matchedIngredients = vm.sortedProducts[vm.indexProductChosen].ingredients;
			console.log('matched ingredients are', vm.matchedIngredients);
		});
	};


  }

})();